"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNotification = exports.StyledNotificationContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var StyledNotificationContainer = _styledComponents["default"].div.withConfig({
  displayName: "styled__StyledNotificationContainer",
  componentId: "wner9d-0"
})(["position:fixed;top:16px;right:0;z-index:10000;display:flex;flex-direction:column;overflow:hidden;height:100%;pointer-events:none;"]);

exports.StyledNotificationContainer = StyledNotificationContainer;

var StyledNotification = _styledComponents["default"].div.withConfig({
  displayName: "styled__StyledNotification",
  componentId: "wner9d-1"
})(["overflow:hidden;z-index:10;transition-property:height,transform,margin-top,z-index;transition-duration:0.2s,0.4s,0.4s,0s;transition-delay:0s,0.2s,0s,0s;margin-bottom:0.5rem;pointer-events:initial;:nth-child(2){z-index:9;}:nth-child(3){transition-property:height,transform,margin-top,z-index;transition-duration:0.2s,0.4s,0.4s,0s;transition-delay:0s,0.2s,0s,0s;z-index:8;}:nth-child(4){transition-property:height,transform,margin-top,z-index;transition-duration:0.2s,0.4s,0.4s,0s;transition-delay:0s,0.2s,0s,0s;margin-top:-21%;transform:scale(0.95);z-index:5;height:68px;text-indent:-1000em;}:nth-child(5){margin-top:-21%;transform:scale(0.9);z-index:1;height:68px;text-indent:-1000em;}:nth-child(n+6){display:none;}transform:translateX(100%);height:0;", " ", ""], function (props) {
  return props.shown && "\n        transform: translateX(0%);\n        height: ".concat(props.height, "px;\n        ");
}, function (props) {
  return props.shouldExit && "\n        transition-property: height, transform, margin-top, z-index;\n        transition-duration: 0.2s, 0.4s, 0.4s, 0s;\n        transition-delay: 0.4s, 0s, 0s, 0.6s;\n        transform: translateX(100%);\n        height: 0;\n        ";
});

exports.StyledNotification = StyledNotification;